// extracted by mini-css-extract-plugin
export default {"no-access-message":"no-access-message_no-access-message__9gI0y"};